import React, { useRef, useState } from 'react';
import '../styles-contact-form.css';
import emailjs from '@emailjs/browser';
import validate from 'validate.js';

export function ContactForm_JS() {
  const form = useRef();

  const constraints = {
    name: {
      presence: { allowEmpty: false, message: "is required" },
      length: { minimum: 2 }
    },
    phone: {
      presence: { allowEmpty: false, message: "is required" },
      format: {
        pattern: /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/,
        message: "must be a valid 10-digit number"
      }
    },
    email: {
      presence: { allowEmpty: false, message: "is required" },
      email: { message: "is not a valid email" }
    },
    message: {
      presence: { allowEmpty: false, message: "is required" },
      length: { minimum: 6 }
    }
  };

  const [formData, setFormData] = useState({ name: '', phone: '', email: '', message: '' });
  const [errors, setErrors] = useState({});

  const handleSubmit = (e) => {
    e.preventDefault();
    
    const validationErrors = validate(formData, constraints);
    
    if (validationErrors) {
      setErrors(validationErrors);
    } else {
      setErrors({});
      sendEmail();
    }
  };

  const sendEmail = () => {
    emailjs
      .sendForm('service_f8xs8cm', 'template_hhy1e6a', form.current, {
        publicKey: 'NUhu8pN8eHhQADIuG',
      })
      .then(
        () => {
          console.log('SUCCESS!');
          
          // 1. Reset state
          setFormData({ name: '', phone: '', email: '', message: '' });
          
          // 2. Clear native DOM inputs
          if (form.current) {
            form.current.reset();
          }

          // Show Notice
          document.querySelector(".form-sent-notice")?.classList.add('animateIT');
        },
        (error) => {
          console.log('FAILED...', error.text);
        },
      );
  };

  return (
    <form className="contact_form" ref={form} onSubmit={handleSubmit} noValidate>
      <div className="flex-columns"> 
        <div className="col-50">
          <label>Name</label>
          <input 
            id="name" 
            type="text" 
            name="name" 
            value={formData.name} 
            onChange={(e) => setFormData({...formData, name: e.target.value})} 
          />
        </div>

        <div className="col-50">
          <label>Phone</label>
          <input 
            id="phone" 
            type="tel" 
            name="phone" 
            value={formData.phone} 
            onChange={(e) => setFormData({...formData, phone: e.target.value})} 
          />
        </div>
      </div>

      <label>Email</label>
      <input 
        id="email" 
        type="email" 
        name="email" 
        value={formData.email} 
        onChange={(e) => setFormData({...formData, email: e.target.value})} 
      />

      <div className="form-message">
        <label>Message</label>
        <textarea 
          id="message" 
          name="message" 
          value={formData.message} 
          onChange={(e) => setFormData({...formData, message: e.target.value})} 
        />
      </div>

      <div className="form-alerts">
        {errors.name && <p>! {errors.name[0]}</p>}
        {errors.phone && <p>! {errors.phone[0]}</p>}
        {errors.email && <p>! {errors.email[0]}</p>}
        {errors.message && <p>! {errors.message[0]}</p>}
      </div>
      
      <div className="form-sent-notice">Your information was sent. I'll get back to you within 24 hours.</div>

      <div className="form-submit"> 
        <input id="form-button" className="form-button" type="submit" value="Send" />
      </div>
    </form>
  );
}